<template lang="pug">
#navigation: .container
    .nav.nav-justified
        .nav-item: router-link.nav-link(to="/", exact)
            font-awesome-icon(icon="home", size="2x")
            | Übersicht
        .nav-item: router-link.nav-link(to="/protokolle")
            font-awesome-icon(icon="list", size="2x")
            | Protokolle
        .nav-item: router-link.nav-link(to="/einstellungen")
            font-awesome-icon(icon="cogs", size="2x")
            | Einstellungen
        .nav-item: router-link.nav-link(to="/hilfe")
            font-awesome-icon(icon="question-circle", size="2x")
            | Hilfe
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faList, faCogs, faMobileAlt, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faHome, faList, faCogs, faMobileAlt, faQuestionCircle)

export default {}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
#navigation {
    border-bottom: 1px solid #ccc;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    background-color: #fff;

    .nav {
        padding-top: 0.6rem;
        padding-bottom: 0.4rem;
    }

    .nav-link {
        text-align: center;
        text-transform: uppercase;
        font-size: 0.85rem;
        letter-spacing: 1.4px;
        color: #888;
        &:hover,
        &.active,
        &.router-link-active {
            color: $primary;
        }
        svg {
            display: block;
            margin: auto;
            margin-bottom: 0.4rem;
        }
    }

    @include media-breakpoint-down(sm) {
        background-color: white;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        padding: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: fixed;
        z-index: 1030;

        .nav-item {
            list-style-type: none;

            .nav-link {
                font-size: 60%;
                padding: 0.7rem 0.5rem 0.5rem;
            }
        }

        .nav {
            padding: 0;
        }
    }
}
</style>
